import type { DialogConfig } from '#types/config/components/dialog'

export default {
  cancelButtonVariant: 'secondary'
} as DialogConfig['cart']
